'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import BlogCard from './blocks/BlogCard';
import { Card, Tab } from './blocks/Tabs/Tabs';

export default function BlogCards({ activeTab, cards = [] }: { activeTab?: Tab; cards: Card[] }) {
    const t = useTranslations();
    const [isCardHovered, setIsCardHovered] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const onMouseMove = (event: React.MouseEvent) =>
        setPosition({ x: event.clientX, y: event.clientY });

    const onMouseEnter = () => setIsCardHovered(true);

    const onMouseLeave = () => setIsCardHovered(false);

    return (
        <>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 relative">
                {cards.map((props, index) => (
                    <BlogCard
                        {...props}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        onMouseMove={onMouseMove}
                        activeTab={activeTab}
                        key={index}
                    />
                ))}
            </div>
            {/* <ArrowLink
              label={t('Common.showAll')}
              href="/"
              className="mt-10 md:hidden max-2xl:text-[22px] text-white"
          /> */}
            {isCardHovered && <CustomCursor label={t('Common.more')} position={position} />}
        </>
    );
}

const CustomCursor = ({
    label,
    position,
}: {
    label: string;
    position: { x: number; y: number };
}) => {
    return (
        <div
            className="fixed z-50 pointer-events-none hidden sm:flex justify-center items-center uppercase font-helvetica-neue font-light text-lg leading-6 tracking-wide"
            style={{
                top: `${position.y - 57}px`,
                left: `${position.x - 57}px`,
                width: '114px',
                height: '114px',
                borderRadius: '50%',
                border: '3px solid white',
                display: position.x !== 0 && position.y !== 0 ? 'flex' : 'none',
            }}
        >
            {label}
        </div>
    );
};
